import toolkitApi from '../../toolkitApi';

import { addRecordSlugs } from './selectors';

const recordsEndpoint = (recordType) =>
    `${window.recordsSettings.franchiseScopedRestUrl}/record-detail` +
    `?cayenneExp=recordCategory="${recordType}"` +
    `&include=recordCategory` +
    `&include=recordType` +
    `&include=recordToFranchise` +
    `&sort=[{"property":"recordType.sequence"},{"property":"recordToFranchise.sequence"}]` +
    `&mapBy=recordType.description`;

export default toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        recordDetails: build.query({
            query: (recordType) => ({
                url: recordsEndpoint(recordType),
            }),
            transformResponse: addRecordSlugs,
        }),
    }),
});
